// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__STyDs","boxTitle":"Qualiphy_boxTitle__2AfIm","box":"Qualiphy_box__3roGl","toggleWrap":"Qualiphy_toggleWrap__1SElz"};